import { InvestorsTableViewTable } from 'TableViews/InvestorsTableViewTable';

export function InvestorTableView(props) {
    const {
        allPositions,
        accountIdToInvestorsAll,
        filteredText,
        backgroundColors,
        panelBackgroundColor,
    } = props;
    return (
        <>
            <InvestorsTableViewTable
                allPositions={allPositions}
                accountIdToInvestorsAll={accountIdToInvestorsAll}
                filteredText={filteredText}
                backgroundColors={backgroundColors}
                panelBackgroundColor={panelBackgroundColor}
            />
        </>
    );
}
